import { useEffect, useRef, useState } from "react";

declare const bootstrap: any;

function Modal({ show, className = "", onHide = () => {}, children }: any) {
  const ref = useRef<HTMLDivElement>(null);

  const [modalInstance, setModalInstance] = useState<any>();

  useEffect(() => {
    let instance: any;

    if (ref.current) {
      instance = new bootstrap.Modal(ref.current, {
        backdrop: "static",
        keyboard: false,
      });
      setModalInstance(instance);
    }

    return () => {
      if (instance) {
        instance.dispose();
      }
    };
  }, [ref]);

  useEffect(() => {
    if (modalInstance) {
      show ? modalInstance.show() : modalInstance.hide();
    }

    
  }, [show]);

  return (
    <div className="modal fade" ref={ref} tabIndex={-1}>
      <div className={`modal-dialog ${className}`}>
        <div className="modal-content">{children}</div>
      </div>
    </div>
  );
}

export default Modal;
